import { useAbsenceApprovals } from '../api/absence';
import { useApprovals } from '../api/holidays';
import { canSeeApprovals } from './access';
import { useSession } from './session';

/**
 * Approvals waiting for the signed-in person: holiday requests (GET /holidays/approvals) plus
 * absence requests (GET /absence/approvals, 2b-M2); 0 for roles that decide neither.
 */
export function usePendingApprovalsCount(): number {
  const { access } = useSession();
  const enabled = canSeeApprovals(access);
  const holidays = useApprovals(enabled);
  const absence = useAbsenceApprovals(enabled);
  if (!enabled) return 0;
  return (holidays.data?.items.length ?? 0) + (absence.data?.items.length ?? 0);
}
